import React from "react";
import LOGO from "../../assets/logo/insightfulTraitsLogo.png";
import MOBILE_LOGO from "../../assets/logo/mobile-logo.png";

const STEPS = ["Test Completed", "Features", "Payment", "Done"];

const HeaderV2 = ({ currentStep = 1 }) => {
  const currentStepName = STEPS[currentStep - 1] || STEPS[0];

  return (
    <div className="block bg-white border-b border-[rgba(43,35,51,0.08)] sticky top-0 z-30">
      {/* < 360px: compact — logo + "Step X of 4 — Name" */}
      <div className="flex min-[360px]:hidden items-center justify-between px-4 py-[14px]">
        <img src={MOBILE_LOGO} alt="InsightfulTraits" className="h-5 w-auto" />
        <span className="font-bold text-[0.78rem] text-status-success-text whitespace-nowrap">
          Step {currentStep} of {STEPS.length} — {currentStepName}
        </span>
      </div>

      {/* >= 360px: logo left + steps right */}
      <div className="hidden min-[360px]:flex max-w-[1180px] mx-auto py-[14px] px-[clamp(16px,4vw,40px)] items-center justify-between gap-3 flex-nowrap">
        {/* Logo */}
        <div className="flex-shrink-0">
          <img
            src={MOBILE_LOGO}
            alt="InsightfulTraits"
            className="block md:hidden h-5 w-auto"
          />
          <img
            src={LOGO}
            alt="InsightfulTraits"
            className="hidden md:block w-[185px] lg:w-[280px] h-auto"
          />
        </div>

        {/* Steps */}
        <div className="flex items-center flex-nowrap w-full justify-between min-[721px]:w-auto min-[721px]:justify-end min-[721px]:gap-[clamp(7px,2vw,20px)]">
          {STEPS.map((label, i) => {
            const done = i < currentStep;
            const cur = i === currentStep;
            return (
              <div
                key={label}
                className="flex items-center gap-1 min-[721px]:gap-2"
              >
                <span
                  className={`w-[26px] h-[26px] rounded-full flex-none flex items-center justify-center font-bold text-[0.78rem]
                    ${
                      done
                        ? "bg-status-danger-bg text-brand-orange-hover"
                        : cur
                          ? "bg-transparent border-2 border-status-success-text text-status-success-text"
                          : "bg-transparent border-2 border-[rgba(43,35,51,0.16)] text-text-light"
                    }`}
                >
                  {done ? "✓" : i + 1}
                </span>
                <span
                  className={`font-bold whitespace-nowrap text-[0.6rem] min-[721px]:text-[clamp(0.72rem,1.5vw,0.86rem)]
                    ${
                      done
                        ? "text-brand-orange-hover"
                        : cur
                          ? "text-status-success-text"
                          : "text-text-light"
                    }`}
                >
                  {label}
                </span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default HeaderV2;
